/* eslint-disable react/prop-types,camelcase */
import React from 'react';

import styled from 'react-emotion';
import { css } from 'emotion';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';

import { Row, Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import { Label } from '~/modules/coreUI/components/basic/Labels';
import Spacer from '~/modules/coreUI/components/layouts/helpers/Spacer';
import { cssMediaMax } from '~/modules/core/utils/cssHelpers/cssMedia';
import Rating from '~/modules/ecommerceCoreUI/components/basic/Rating';
import Follow from '~/modules/ecommerceCoreUI/components/productDetails/vendor/buttons/Follow';
import urlFor from '~/modules/ecommerceCore/utils/UrlConcatination';
import externalRedirect from '~/modules/ecommerceCore/utils/externalRedirect';

const ShopImage = styled.img`
  width: 99px;
  height: 100px;
  border: solid ${props => props.theme.borders.size.thin}px #e5e5e5;
  border-radius: ${props => props.theme.borders.radius.normal}px;
  object-fit: cover;
`;
const customLabelStyle = props => css`
  color: ${props.theme.colors.labels.important};
  text-transform: capitalize;
  letter-spacing: -0.3px;
  ${cssMediaMax.xsmall`
    font-size: 18px;
    letter-spacing: -0.2px;
  `};
`;
const ratingCountStyle = props => css`
  font-size: 15.5px;
  color: ${props.theme.colors.labels.emphasized};
  margin-left: ${props.theme.paddings.normal}px;
  ${cssMediaMax.xsmall`
    font-size: 13px;
  `};
`;
const SpacerStyle = styled(Spacer)`
  ${cssMediaMax.xsmall`
    width: 10px;
    height: 10px;
  `};
`;

const vendorInfoStyle = css`
  margin-top: 10px; /* TEMPORARY */
`;

const ShopName = styled(Label)`
  cursor: pointer;
`;

const shopContent = (ratingSize, props) => (
  <React.Fragment>
    <div>
      <ShopName
        xxl
        customStyle={customLabelStyle}
        onClick={() => externalRedirect(urlFor('getProductTracksLink', [null, props.ref_id, props.name]))}
      >
        {props.name}
      </ShopName>
      <SpacerStyle size={1.5} />
      <Rating rating={props.avg_rating} ratingCount={props.rating_count} starsSize={ratingSize} customCountStyles={ratingCountStyle} />
      <Spacer size={1} />
    </div>
    <Follow followed={props.follow} size={['xs', 'sm']} vendorId={props.ref_id} />
  </React.Fragment>
);
const VendorInfo = props => (
  <Row topAligned className={vendorInfoStyle}>
    <ShopImage src={props.logo_url} alt={props.logo_url} />
    <Spacer size={1.5} />
    {props.media.xsmall ? (
      <Column leftAligned>{shopContent(21, props)}</Column>
    ) : (
      <Row spaceBetweenJustified topAligned fullWidth>
        {shopContent(26, props)}
      </Row>
    )}
  </Row>
);

export default withMedia(VendorInfo);
